// src/services/employeeApi.js
// Servicio para empleados / groomers (employee.php)

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Lista empleados
 * GET employee.php
 * Query opcional: role=GROOMER
 */
export const getEmployees = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    if (params.role) searchParams.append('role', params.role);
    const query = searchParams.toString();
    const url = query ? `/employee.php?${query}` : '/employee.php';
    const response = await dotoniwoofApi.get(url);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al listar empleados:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene empleados con rol GROOMER (para asignar a citas)
 */
export const getGroomers = async () => {
  return getEmployees({ role: 'GROOMER' });
};

/**
 * Obtiene un empleado por ID
 * GET employee.php/{id}
 */
export const getEmployeeById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`/employee.php/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener empleado:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crea un empleado
 * POST employee.php
 * Body: id_person o person: { name, document, id_document_type, id_person_type, ... }; opcionales: salary, initial_date, end_date, id_status, id_role, agenda_color
 */
export const createEmployee = async (employeeData) => {
  try {
    const response = await dotoniwoofApi.post('/employee.php', employeeData);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear empleado:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualiza un empleado
 * PUT employee.php/{id}
 * Body opcionales: salary, initial_date, end_date, id_status, id_role, agenda_color
 */
export const updateEmployee = async (id, employeeData) => {
  try {
    const response = await dotoniwoofApi.put(`/employee.php/${id}`, employeeData);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar empleado:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Elimina un empleado
 * DELETE employee.php/{id}
 */
export const deleteEmployee = async (id) => {
  try {
    const response = await dotoniwoofApi.delete(`/employee.php/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar empleado:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
